export default "__VITE_ASSET__DEv_Ph67__"